import { Expression } from "./Expression";
import { TemplateContext } from "../Template";
import { Observable, observable, Signal, Subscription } from "../../Signal";
import { compile } from "../Compiler";

/**
 * Super class of expressions that will invoke a closure on observable dispatch.
 */
export class ClosureExpression extends Expression {

	subscription: Subscription;


	constructor( context:TemplateContext, expression:string ) {
		super( context );
		this.expression = compile( expression, [ 'event','data' ] );
	}

	subscribe( observable:Observable<any> ) {
		this.unsubscribe();
		this.subscription = observable.subscribe( this.invoke.bind( this ) );
	}

	unsubscribe() {
		if( this.subscription ) this.subscription.unsubscribe();
	}

	invoke( event ) {
		this.expression.call( this.context, event, this.context.data );
	}

	destroy() {
		this.unsubscribe();
	}
}


/**
 * This class subscribes node events and invokes the corresponding closure like: <div on-click="[[ ... ]]"></div>
 */
export class NodeEventExpression extends ClosureExpression {

	event:string;
	node:Node;

	constructor( context:TemplateContext, expression:string, event:string, node:Node ) {
		super( context, expression );
		this.event = event;
		this.node = node;

		this.updateSubscription();
	}

	updateSubscription() {
		this.subscribe( observable( this.event, this.node ) );
	}
}



